import {ModalContextInterface} from '../hooks/ModalContext';

export const confirm = (message: string, confirm: any, modalContext?: ModalContextInterface) => {
   window.scrollTo(0, 0);
   modalContext?.setConfirm(confirm);
   //modalContext?.setShowConfirm(false);
   modalContext?.setConfirmDesc(message);
   modalContext?.setShowConfirm(true);
};
